import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import RightArrow from "@/icons/RightArrow";
import { cn } from "@/lib/utils";
import {
  AddNewBreadcrum,
  RemoveBreadcrum,
} from "@/redux/slices/breadcrumSlice";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const excludeBreadcrumbs = [
  "Deals & Clearance",
  "Deals",
  "Shop Outlet",
  "Rebate Offers",
];

const modifiedBredcrumbValues = {
  "All Refrigerators": "Refrigerators & Freezers",
};

const CustomBreadcrumb = ({ className }) => {
  const breadcrumbItems = useSelector((state) => state.breadcrumbs);
  const dispatch = useDispatch();
  const pathname = usePathname();
  let modifiedBreadcrumbs = breadcrumbItems?.filter(
    (item) => !excludeBreadcrumbs.includes(item.name)
  );

  useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname.split("/").at(-1);
      const formattedPath = path
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      const breadcrumbItem = {
        name: modifiedBredcrumbValues[formattedPath] ?? formattedPath,
        url: window.location.pathname,
      };
      if (!breadcrumbItem.name) return;
      dispatch(AddNewBreadcrum([breadcrumbItem]));
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      setTimeout(() => {
        window.removeEventListener("popstate", handlePopState);
      }, 0);
    };
  }, [dispatch, AddNewBreadcrum, pathname]);

  useEffect(() => {
    if (breadcrumbItems.length === 0 && pathname) {
      const path = pathname.split("/").at(-1);
      const formattedPath = path
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      const breadcrumbItem = {
        name: modifiedBredcrumbValues[formattedPath] ?? formattedPath,
        url: pathname,
      };
      
      if (pathname.includes("/all-brands")) {
        dispatch(
          AddNewBreadcrum([
            {
              name: "All Brands",
              url: "/brands",
            },
            breadcrumbItem,
          ])
        );
      } else if (pathname.includes("/luxury-appliances-products")) {
        dispatch(
          AddNewBreadcrum([
            {
              name: "Luxury Appliances",
              url: "/luxury-appliances",
            },
            breadcrumbItem,
          ])
        );
      } else {
        dispatch(AddNewBreadcrum([breadcrumbItem]));
      }
    }
  }, [pathname, breadcrumbItems]);

  const onBreadrumbClick = (index) => {
    const updatedBreadcrumbs = modifiedBreadcrumbs.slice(0, index);

    dispatch(RemoveBreadcrum(updatedBreadcrumbs));
  };
  
  function formatUrl(url) {
    return url?.startsWith("/") ? url : "/" + url;
  }

  modifiedBreadcrumbs = modifiedBreadcrumbs.map((item) => {
    if (item.url === "/all-brands/bosch/dishwashers") {
      return {
        ...item,
        name: "BOSCH Free Dishwasher Pods Promotion",
      };
    }
    return item;
  });
  
  return (
    <div
      className={cn(
        "px-5 container max-w-1440 py-5 lg:bg-mobileBG lg:p-[14px]",
        className
      )}
    >
      <Breadcrumb>
        <BreadcrumbList className="font-light text-[13px] leading-[20px] gap-[1px]">
          {modifiedBreadcrumbs.length > 0 &&
            [{ url: "/", name: "Home" }, ...modifiedBreadcrumbs]?.map(
              (item, index, array) => (
                <React.Fragment key={index}>
                  <BreadcrumbItem>
                    {index !== array.length - 1 ? (
                      <Link
                        href={formatUrl(item.url)}
                        onClick={() => onBreadrumbClick(index)}
                      >
                        {item.name}
                      </Link>
                    ) : (
                      <BreadcrumbPage className="text-gray8 font-medium truncate max-w-72">
                        {item.name}
                      </BreadcrumbPage>
                    )}
                  </BreadcrumbItem>
                  {index < array.length - 1 && (
                    <BreadcrumbSeparator className="[&>svg]:size-2.5 px-1">
                      <RightArrow />
                    </BreadcrumbSeparator>
                  )}
                </React.Fragment>
              )
            )}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};

export default CustomBreadcrumb;